/* Configuration du thème global de l'application
   J'ai opté pour une palette luxueuse et "internationale" */
   const theme = {
    colors: {
      /* Palette principale, j'ai choisi des couleurs sobres et élégantes */
      primary: '#2F3640',        // Anthracite profond pour le sérieux
      secondary: '#C4A47C',      // Beige doré pour l'élégance discrète
      tertiary: '#5D6D7E',       // Gris-bleu pour la modernité
      
      /* Couleurs d'accent pour les différents états */
      accent: '#8B7355',         // Bronze mat, richesse discrète
      success: '#27AE60',        // Vert émeraude, croissance
      warning: '#E67E22',        // Orange cuivré, attention
      error: '#C0392B',          // Rouge bordeaux, sérieux
      info: '#3498DB',           // Bleu clair, information
      
      /* Variations de couleurs pour plus de nuances */
      primaryLight: '#4A5568',
      primaryDark: '#1A1D23',
      primaryFaded: '#2F364040',
      secondaryLight: '#D4B896',
      secondaryDark: '#B3966F',
      secondaryFaded: '#C4A47C40',
      tertiaryLight: '#7B8794',
      tertiaryDark: '#4A5A6A',
      
      /* Couleurs de texte pour une hiérarchie claire */
      textPrimary: '#2C3E50',
      textSecondary: '#566573',
      textLight: '#FDFDFD',
      textMuted: '#85929E',
      
      /* Arrière-plans sophistiqués */
      background: '#FEFEFE',
      backgroundLight: '#F8F9FA',
      backgroundDark: '#2C3E50',
      backgroundAccent: '#F5F6F8',
      backgroundLuxury: '#F7F8FA',
      
      /* Couleurs spéciales pour des éléments premium */
      gold: '#D4AF37',
      silver: '#C0C0C0',
      platinum: '#E5E4E2',
      
      /* Gradients subtils pour ajouter de la profondeur */
      gradientPrimary: 'linear-gradient(135deg, #2F3640 0%, #4A5568 100%)',
      gradientSecondary: 'linear-gradient(135deg, #C4A47C 0%, #D4B896 100%)',
      gradientHero: 'linear-gradient(135deg, #2F3640 0%, #5D6D7E 50%, #C4A47C 100%)',
      gradientCard: 'linear-gradient(135deg, #FEFEFE 0%, #F8F9FA 100%)',
      gradientLuxury: 'linear-gradient(135deg, #F7F8FA 0%, #F5F6F8 100%)',
    },
    
    /* Typographie luxueuse et lisible */
    fonts: {
      primary: "'Cormorant Garamond', serif",    // Élégante pour les titres
      secondary: "'Inter', sans-serif",          // Moderne pour le corps
      accent: "'Crimson Text', serif",           // Distinctive pour les accents
      luxury: "'Playfair Display', serif",       // Pour les éléments premium
      modern: "'Poppins', sans-serif",          // Alternative moderne
      monospace: "'JetBrains Mono', monospace"  // Pour les données
    },
    
    /* Tailles de police harmonieuses basées sur une échelle */
    fontSizes: {
      xs: '0.75rem',     // 12px
      sm: '0.875rem',    // 14px
      md: '1rem',        // 16px (base)
      lg: '1.125rem',    // 18px
      xl: '1.25rem',     // 20px
      xxl: '1.5rem',     // 24px
      xxxl: '2rem',      // 32px
      huge: '2.5rem',    // 40px
      massive: '3rem',   // 48px
      giant: '4rem',     // 64px
    },
    
    /* Poids de police pour créer de la hiérarchie */
    fontWeights: {
      thin: 100,
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
      black: 900,
    },
    
    /* Système d'espacement cohérent */
    spacing: {
      xs: '0.25rem',     // 4px
      sm: '0.5rem',      // 8px
      md: '1rem',        // 16px
      lg: '1.5rem',      // 24px
      xl: '2rem',        // 32px
      xxl: '3rem',       // 48px
      xxxl: '4rem',      // 64px
      huge: '6rem',      // 96px
      massive: '8rem',   // 128px
    },
    
    /* Rayons de bordure pour adoucir les angles */
    borderRadius: {
      none: '0',
      xs: '0.125rem',    // 2px
      sm: '0.25rem',     // 4px
      md: '0.5rem',      // 8px
      lg: '1rem',        // 16px
      xl: '1.5rem',      // 24px
      xxl: '2rem',       // 32px
      pill: '50rem',     // Forme pilule
      circle: '50%',     // Cercle parfait
    },
    
    /* Ombres subtiles pour créer de la profondeur */
    shadows: {
      none: 'none',
      xs: '0 1px 2px rgba(0, 0, 0, 0.04)',
      sm: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)',
      md: '0 4px 6px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.04)',
      lg: '0 10px 15px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.05)',
      xl: '0 20px 25px rgba(0, 0, 0, 0.10), 0 10px 10px rgba(0, 0, 0, 0.04)',
      xxl: '0 25px 50px rgba(0, 0, 0, 0.12)',
      inner: 'inset 0 2px 4px rgba(0, 0, 0, 0.03)',
      luxury: '0 8px 25px rgba(196, 164, 124, 0.15)',  // Ombre dorée subtile
      discrete: '0 2px 8px rgba(47, 54, 64, 0.08)',    // Ombre discrète
    },
    
    /* Points de rupture pour le responsive */
    breakpoints: {
      xs: '320px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1920px',
    },
    
    /* Transitions fluides avec différentes courbes */
    transitions: {
      instant: 'all 0.1s ease',
      fast: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      normal: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      slow: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      luxury: 'all 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
      discrete: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    
    /* Z-index organisés pour éviter les conflits */
    zIndex: {
      hide: -1,
      base: 0,
      content: 10,
      dropdown: 100,
      sticky: 200,
      backdrop: 300,
      modal: 400,
      popover: 500,
      tooltip: 600,
      overlay: 700,
      maximum: 999,
    },
  }
  
  export default theme
  